export default __webpack_public_path__ + "static/media/person-2.826b8c3c.jpg";